/**
 * Single Special Project – Image / Video Modal
 */
import { initPostMediaModal } from './post-media-modal.js';

initPostMediaModal();
